$(document).ready(() => {
    $('.library-page-result input#QueryString').change((e) => filter(e));
    $('.library-page-result button').click((e) => createLibraryItemRequestForm(e));
});

function filter(e) {
    submitForm(e);
}

function submitForm(e) {
    var form = $("#library-filter-form");
    var html = $(e.target).closest('.library-page-result')[0];

    var valdata = $(form).serialize();

    $.ajax({
        url: $(form).attr('action'),
        type: 'Get',
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        data: valdata,
        success: function (data) {
            $(html).html(data);
            $('.library-page-result input#QueryString').change((e) => filter(e));
            $('.library-page-result button').click((e) => createLibraryItemRequestForm(e));
        },
    });
}

function removeLibraryItemRequestForm() {
    $(".library-page-result .library-item-button.active").removeClass("active");
    $('.library-page-result .library-item-request-form').remove();
}

function createLibraryItemRequestForm(e) {
    var removeForm = $(e.target).hasClass("active");
    removeLibraryItemRequestForm();
    if (removeForm) {
        return;
    }
    getLibraryItemRequestForm(e);
    $(e.target).addClass("active");
}

function getLibraryItemRequestForm(e) {
    var form = $(e.target).closest('form')[0];
    var html = $(e.target).closest('.grid-item');

    var valdata = $(form).serialize();

    $.ajax({
        url: '/umbraco/Surface/LibraryPage/GetLibraryItemRequestForm/',
        type: 'Get',
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        data: valdata,
        success: function (data) {
            $(html).after(data);
            $('.library-page-result .library-item-close-request-form-button').click((e) => removeLibraryItemRequestForm());
            $('#library-item-request-form').on("submit", function (e) { submitLibraryItemRequestForm(e) });
        },
    });
}

function submitLibraryItemRequestForm(e) {
    e.preventDefault();
    var form = $(e.target).closest('form');
    var valdata = $(form[0]).serialize();

    $.ajax({
        url: $(form[0]).attr('action'),
        type: 'Post',
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        data: valdata,
        success: function (data) {
            if (data.validEmail == true) {
                $('#library-item-request-form-input-group').empty();
                $('#library-item-request-form-header').html(data.responseMessage);
            }
            else {
                $('.library-item-request-form-email-input-validation').html(data.responseMessage);
            }
        }
    });
};